import Vue from "vue";
import Vuex from "vuex";
import authentication from "./authentication/module";
import accounts from "./accounts/module";
import cards from "./cards/module";
import cms from "./cms/module";
import invites from "./invites/module";
import vehicles from "./vehicles/module";
import settings from "./settings/module";

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    authentication,
    accounts,
    cards,
    cms,
    invites,
    vehicles,
    settings
  }
});
